<template>
  <div class="modal fade" id="saveTemplateModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content p-4">
        <div class="modal-header border-0">
          <h3 class="modal-title font-weight-bold text-secondary">Vorlage speichern</h3>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form v-on:submit.prevent="saveTemplate">
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <input class="form-control" placeholder="Bezeichnung" name="template-name" v-model="templateName" required>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer border-0 pt-2">
          <div class="dokubtns text-right border-0 p-0 m-0">
            <span class="btninner">
              <button type="reset" class="btn btn-red" data-dismiss="modal">
               {{ $t('cancel') }}
              </button>
              <button type="submit" class="btn btn-blue">
               {{ $t('save') }}
              </button>
            </span>
          </div>
        </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['params'],
  data () {
    return {
      templateName: '',
    }
  },
  mounted () {

  },
  computed: {
    // params :{
    //   get(){
    //     return this.$store.state.appSettings.project.params || [];
    //   },set(val){
    //     this.$store.commit("setProjectParams",val)
    //   }
    // },
    project(){
      return this.$store.state.appSettings.project
    },
    userId () {
      return this.$store.state.projects.user.pduserid
    }
  },

  methods: {
    async saveTemplate(){
      $('#saveTemplateModal').modal('toggle');
      this.$store.commit('settingsModuleSetLoading',true);
      let user_id = this.project.customer_id

      let paramdata = []
      let count = 0
      this.params.forEach(group => {
        group.items.forEach(item => {
          if (item.projectparamid && item.projectparamid.startsWith('new')) {
            delete item.projectparamid
          }
          item.order = ++count
          paramdata.push(item)
        })
      })



      let data = {
        projecttemplateid: 0,
        customer_id: user_id,
        dailydocutype: this.project.dailydocu,
        is_default: 0,
        name: this.templateName,
        params: paramdata,
        photoquality: this.project.photoquality,
        _explicitType: "com\\projectdocu\\ProjectTemplateVO"
      }
      await this.$store.dispatch('saveSettingsTemplate', [ data ])
      this.$store.commit('settingsModuleSetLoading',false);
    }
  }
}
</script>

<style scoped>
#saveTemplateModal .modal-dialog {
  max-width: 30%;
}

#templateModal select, #templateModal input {
  font-size: 1.04rem;
}
</style>



// WEBPACK FOOTER //
// src/components/appSetting/components/SaveSettingsTemplate.vue